import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import CreatorCrm from '@/views/creators/creator-crm';
import Profile from '@/views/creators/profile/Profile';
import SpinningLoader from '@/components/spinning-loader';

export const CREATOR_CRM_ROUTES = {
  MAIN: '',
  CREATOR_PROFILE: `${ROUTES.CREATOR_PROFILE}/:creatorId`,
};

function CreatorCrmRoutes() {
  return (
    <Routes>
      <Route path={CREATOR_CRM_ROUTES.MAIN} element={<CreatorCrm />} />
      <Route
        path={CREATOR_CRM_ROUTES.CREATOR_PROFILE}
        element={
          <Profile
            customLoader={
              <SpinningLoader color="black" containerHeight="100%" />
            }
          />
        }
      />
    </Routes>
  );
}

export default CreatorCrmRoutes;
